import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import { useI18n } from "vue-i18n";

dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

export function setupDayjsLocale(i18n: ReturnType<typeof useI18n>) {
  const { t } = i18n;

  dayjs.updateLocale("en", {
    relativeTime: {
      future: t("time-future", {
        time: "%s",
      }),
      past: t("time-past", {
        time: "%s",
      }),
      s: t("time-a-few-seconds"),
      m: t("time-1-minute"),
      mm: t("time-x-minutes", {
        number: "%d",
      }),
      h: t("time-1-hour"),
      hh: t("time-x-hours", {
        number: "%d",
      }),
      d: t("time-1-day"),
      dd: t("time-x-days", {
        number: "%d",
      }),
      M: t("time-1-month"),
      MM: t("time-x-months", {
        number: "%d",
      }),
      y: t("time-1-year"),
      yy: t("time-x-years", {
        number: "%d",
      }),
    },
  });
}
